<template>
  <div>
    <el-form :model="searchForm" inline >
      <el-form-item label="会议日期">
        <el-date-picker
          v-model="searchForm.time"
          :clearable="false"
          size="small"
          type="daterange"
          range-separator="至"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"/>
      </el-form-item>
      <el-form-item label="参会人">
        <!-- <el-input v-model="searchForm.workcode" size="small" clearable></el-input> -->
        <el-select
          v-model="searchForm.workcode"
          :remote-method="filterList"
          :autosize="{maxRows:3}"
          clearable
          filterable
          remote
          multiple
          value-key="workcode"
          style="width:600px"
          size="small"
          @change="changeSelect">
          <el-option v-for="(item,index) in userList" :key="index" :value="item.name+'('+item.workcode+')'" :label="item.name+'('+item.workcode+')'"/>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="mini" type="primary" icon="el-icon-search" @click="searchList()">查询</el-button>
        <el-button size="mini" type="primary" @click="download()">导出总表</el-button>
        <el-button size="mini" type="primary" @click="downDetails()">导出详表</el-button>
      </el-form-item>
    </el-form>
    <el-table v-loading="loading" :data="dataList" :header-cell-style="{background:'#409eff',padding:'8px 0',color:'#fff'}" size="small" border style="margin-top: 20px">
      <el-table-column label="编号" prop="num" width="80" align="center">
        <template slot-scope="scope">
          <span>{{ scope.$index +1 }}</span>
        </template>
      </el-table-column>
      <el-table-column label="会议日期" prop="dateTime" align="center"/>
      <el-table-column label="姓名" prop="name" align="center">
        <template slot-scope="scope">
          <span class="forDetail" title="查看详情" @click="goDetail(scope.row)">{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="工号" prop="workcode" align="center"/>
      <el-table-column label="岗位" prop="station" align="center"/>
      <el-table-column label="会议总次数" prop="totalNums" align="center"/>
      <el-table-column label="会议总时长(小时)" prop="totalTimes" align="center"/>
      <el-table-column label="早会次数" prop="morning_nums" align="center"/>
      <el-table-column label="晚会次数" prop="night_nums" align="center"/>
      <el-table-column label="大杂会数量" prop="other_nums" align="center"/>
    </el-table>
    <div style="margin-top: 10px; text-align:center">
      <el-pagination
        :page-sizes="[10,20,50,100]"
        :total="total"
        :page-size="pageSize"
        :current-page="page"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"/>
    </div>
  </div>
</template>
<script>
import { gitusers } from '@/api/user'
import { getStaticList } from '@/api/static'
import axios from 'axios'
export default {
  name: 'TabPerson',
  data() {
    return {
      searchForm: {
        time: [],
        workcode: []
      },
      loading: false,
      dataList: [],
      allUsers: [],
      userList: [],
      page: 1,
      pageSize: 10,
      total: 0,
      today: ''
    }
  },
  created() {
    this.getAllUser()
    const now = new Date()
    now.setTime(now.getTime() - 24 * 60 * 60 * 1000)
    const Y = now.getFullYear()
    const M = (now.getMonth() + 1) < 10 ? '0' + (now.getMonth() + 1) : now.getMonth() + 1
    const D = now.getDate() < 10 ? '0' + now.getDate() : now.getDate()
    const today = Y + '-' + M + '-' + D
    this.searchForm.time = [today, today]
    this.today = today
    // 从store取存储的时间，防止用户查看详情后再次点击列表，时间重置（点击左侧菜单栏时，重置时间为当前日期）
    this.page = this.$store.state.countParams.page
    this.pageSize = this.$store.state.countParams.page_size
    this.searchForm.time = this.$store.state.countParams.time.length === 0 ? [today, today] : this.$store.state.countParams.time
    this.searchForm.workcode = this.$store.state.countParams.workcode
    this.getListData()
  },
  beforeMount() {

  },
  methods: {
    getAllUser() {
      gitusers({ departmentId: 0 }).then(response => {
        console.log(response)
        if (response.code === '000000') {
          this.allUsers = response.data
        } else {
          this.allUsers = []
        }
      })
    },
    searchList() {
      this.page = 1
      this.getListData()
      console.log(this.searchForm)
    },
    getListData() {
      // 处理人员
      const attends = []
      if (this.searchForm.workcode.length > 0) {
        this.searchForm.workcode.forEach(item => {
          const str = item.replace(/\(/g, ' ').replace(/\)/g, ' ')
          attends.push(str.split(' ')[1])
        })
      }
      const params = {
        start_time: this.searchForm.time ? this.searchForm.time[0] : '',
        end_time: this.searchForm.time ? this.searchForm.time[1] : '',
        workcode: attends,
        page: this.page,
        page_size: this.pageSize
      }
      const obj = {
        time: this.searchForm.time,
        workcode: this.searchForm.workcode,
        page: this.page,
        page_size: this.pageSize
      }
      // 将选择的时间存起来，再次点开tab时候用此时间填充
      this.$store.dispatch('SET_PARAMS', obj)

      this.loading = true
      getStaticList(params).then(res => {
        console.log(res)
        this.loading = false
        if (res.code === 'success' && res.data.data) {
          const dateTime = this.searchForm.time[0] === this.searchForm.time[1] ? this.searchForm.time[0] : this.searchForm.time[0] + ' ~ ' + this.searchForm.time[1]
          res.data.data.forEach(item => {
            item.totalNums = 0
            item.totalTimes = 0
            item.dateTime = dateTime
            if (item.morning_nums > 0) {
              item.totalNums += item.morning_nums
              item.totalTimes += parseFloat(item.morning_minute ? item.morning_minute : 0)
            }
            if (item.night_nums > 0) {
              item.totalNums += item.night_nums
              item.totalTimes += parseFloat(item.night_minute ? item.night_minute : 0)
            }
            if (item.other_nums > 0) {
              item.totalNums += item.other_nums
              item.totalTimes += parseFloat(item.other_minute ? item.other_minute : 0)
            }
            item.totalTimes = (parseFloat(item.totalTimes) / 60).toFixed(2)
          })
          this.dataList = res.data.data
          this.total = res.data.total
        } else {
          this.total = 0
          this.dataList = []
        }
      }).catch(() => {
        this.loading = false
        this.total = 0
        this.dataList = []
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getListData()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getListData()
    },
    filterList(val) {
      if (val) {
        setTimeout(() => {
          this.userList = this.allUsers.filter(item => {
            return item.name.toLowerCase().indexOf(val.toLowerCase()) > -1
          })
        }, 200)
      } else {
        this.userList = []
      }
    },
    changeSelect(val) {
      this.searchForm.workcode = []
      if (val.length > 0) {
        val.forEach(item => {
          this.searchForm.workcode.push(item)
        })
      } else {
        this.searchForm.workcode = []
      }
    },
    goDetail(item) {
      console.log(item)
      // const saveData = {
      //   date: this.searchForm.time,
      //   person: item.workcode
      // }
      // this.$store.dispatch('SET_DATE', saveData)
      sessionStorage.setItem('date', this.searchForm.time)
      sessionStorage.setItem('person', item.workcode)
      this.$router.push({ name: 'personCount' })
    },
    // 下载总表
    download() {
      const attends = []
      if (this.searchForm.workcode.length > 0) {
        this.searchForm.workcode.forEach(item => {
          const str = item.replace(/\(/g, ' ').replace(/\)/g, ' ')
          attends.push(str.split(' ')[1])
        })
      }
      const params = {
        start_time: this.searchForm.time ? this.searchForm.time[0] : '',
        end_time: this.searchForm.time ? this.searchForm.time[1] : '',
        workcode: attends
      }
      let message = ''
      let fileName = ''
      if (params.start_time === params.end_time) {
        message = `下载 ${params.start_time} 日的总表数据？`
        fileName = `${params.start_time}日统计表.xls`
      } else {
        message = `下载 ${params.start_time}日 到 ${params.end_time}日的总表数据？`
        fileName = `${params.start_time}至${params.end_time}统计表.xls`
      }
      this.$confirm(message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios({
          // url: 'http://190.168.1.50:9095/api/statistics/exportAttendees', // 测试
          url: `${process.env.VUE_APP_BASE_API}/statistics/exportAttendees`, // 生产
          method: 'post',
          data: params,
          headers: { Authorization: this.$store.getters.token },
          responseType: 'blob'
        }).then(res => {
          console.log(res)
          const blobUrl = window.URL.createObjectURL(res.data)
          download(blobUrl)
          function download(blobUrl) {
            const aa = document.createElement('a')
            aa.style.display = 'none'
            aa.download = fileName
            aa.href = blobUrl
            aa.click()
            // document.body.removeChild(aa);
          }
        })
      }).catch(() => {

      })
    },
    // 下载详表
    downDetails() {
      const attends = []
      if (this.searchForm.workcode.length > 0) {
        this.searchForm.workcode.forEach(item => {
          const str = item.replace(/\(/g, ' ').replace(/\)/g, ' ')
          attends.push(str.split(' ')[1])
        })
      }
      const params = {
        start_time: this.searchForm.time ? this.searchForm.time[0] : '',
        end_time: this.searchForm.time ? this.searchForm.time[1] : '',
        workcode: attends
      }
      let message = ''
      let fileName = ''
      if (params.start_time === params.end_time) {
        message = `下载 ${params.start_time} 日的详情表数据？`
        fileName = `${params.start_time}日详情表.xls`
      } else {
        message = `下载 ${params.start_time}日 到 ${params.end_time}日的详情表数据？`
        fileName = `${params.start_time}至${params.end_time}详情表.xls`
      }
      this.$confirm(message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios({
          // url: 'http://190.168.1.50:9095/api/statistics/exportAttendeesDetail', // 测试
          url: `${process.env.VUE_APP_BASE_API}/statistics/exportAttendeesDetail`, // 正式
          method: 'post',
          data: params,
          headers: { Authorization: this.$store.getters.token },
          responseType: 'blob'
        }).then(res => {
          console.log(res)
          const blobUrl = window.URL.createObjectURL(res.data)
          download(blobUrl)
          function download(blobUrl) {
            const aa = document.createElement('a')
            aa.style.display = 'none'
            aa.download = fileName
            aa.href = blobUrl
            aa.click()
            // document.body.removeChild(aa);
          }
        })
      }).catch(() => {

      })
    }
  }
}
</script>
<style lang="scss">
  .forDetail{
    color:#6d9eeb;
    cursor: pointer;
    &:hover{
      text-decoration: underline;
      color: #4183ea;
    }
  }
</style>
